// extracted by mini-css-extract-plugin
export default {"balance":"style_balance__7PMFt","count":"style_count__+q9Xa","label":"style_label__0O+L1","scan":"style_scan__mLy7d"};